module.exports = __webpack_public_path__ + "img/sendSms.cd62b529.png";